export default __webpack_public_path__ + "static/rw-c459597825fc033b83a0ba43cb9589f0.svg";